import * as React from 'react';
import * as ReactDOM from 'react-dom';
import thunk from 'redux-thunk';
import { createStore, applyMiddleware } from 'redux';
import { rootReducer } from './reducers/index';
import { SearchBarComponent, MobileSearchBarComponent, ShopSearchBarComponent } from '../global/components/header/search-bar'
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';


var createStoreWithMiddleware = applyMiddleware(thunk)(createStore);
var store = createStoreWithMiddleware(rootReducer);

const searchBar = document.getElementById('search-bar-component');


if (searchBar != undefined) {
    const searchBarRoot = createRoot(searchBar);
    searchBarRoot.render(
        <Provider store={store}>
            <SearchBarComponent />
        </Provider>
    );
}


// Mobile
const mobileSearchBar = document.getElementById('mobile-search-bar-component');

if (mobileSearchBar != undefined) {
    const mobileSearchBarRoot = createRoot(mobileSearchBar);
    mobileSearchBarRoot.render(
        <Provider store={store}>
            <MobileSearchBarComponent />
        </Provider>
    );
}

// Shop
const shopSearchBar = document.getElementById('shop-search-bar-component');
if (shopSearchBar != undefined) {
    const shopSearchBarRoot = createRoot(shopSearchBar);
    shopSearchBarRoot.render(
        <Provider store={store}>
            <ShopSearchBarComponent />
        </Provider>
    );
}